import { Link } from 'react-router-dom';

const NutzungsbedingungenPage = () => {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Nutzungsbedingungen</h1>
        <p className="text-sm text-gray-500 mb-8">Stand: Juli 2026</p>

        <div className="prose prose-gray max-w-none">
          <h2 className="text-xl font-semibold mt-6 mb-3">1. Geltungsbereich</h2>
          <p>
            Diese Nutzungsbedingungen gelten für die Nutzung des Förderfuchs Social Media Managers
            (nachfolgend "Plattform"). Mit der Nutzung der Plattform erklären Sie sich mit diesen
            Bedingungen einverstanden.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">2. Beschreibung des Dienstes</h2>
          <p>
            Der Förderfuchs Social Media Manager ist eine KI-gestützte Plattform zur:
          </p>
          <ul className="list-disc pl-6 my-4">
            <li>Planung und Erstellung von Social-Media-Inhalten (fertiger Marken-Monatsplan)</li>
            <li>Direktveröffentlichung auf unterstützten Kanälen (derzeit Bluesky) sowie Bereitstellung fertiger Beiträge zum Export/Kopieren für weitere Netzwerke (u.&nbsp;a. Facebook, Instagram, LinkedIn); der Umfang direkt anbindbarer Kanäle wird laufend erweitert</li>
            <li>Analyse und Optimierung von Social-Media-Profilen</li>
            <li>Verwaltung von Redaktionsplänen</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-3">3. Entgelt, Laufzeit, Kündigung</h2>
          <ul className="list-disc pl-6 my-4">
            <li>Die Nutzung ist 14 Tage kostenlos und ohne Hinterlegung eines Zahlungsmittels testbar; danach wählen Sie aktiv einen kostenpflichtigen Plan — es erfolgt keine automatische Abbuchung aus dem Test heraus.</li>
            <li>Es gelten die bei Bestellung angezeigten Preise (Endpreise; gemäß §&nbsp;19 UStG wird keine Umsatzsteuer berechnet). Die Abrechnung erfolgt über den Zahlungsdienstleister Stripe.</li>
            <li>Monatsabos verlängern sich jeweils um einen Monat und sind jederzeit zum Ende des laufenden Abrechnungsmonats kündbar. Jahresabos haben eine Erstlaufzeit von 12 Monaten; nach Ablauf verlängern sie sich auf unbestimmte Zeit und sind dann monatlich kündbar.</li>
            <li>Die Kündigung ist jederzeit in den Einstellungen oder formlos per E-Mail an schuchardt@foerderfuchs-bildung.de möglich.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-3">4. Widerrufsrecht für Verbraucher</h2>
          <p>Verbrauchern (§&nbsp;13 BGB) steht ein gesetzliches Widerrufsrecht zu:</p>
          <h3 className="text-lg font-medium mt-4 mb-2">Widerrufsbelehrung</h3>
          <p>
            Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu
            widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsschlusses.
            Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (Nina Schuchardt — Förderfuchs,
            Brentanoweg 12, 45731 Waltrop, E-Mail: schuchardt@foerderfuchs-bildung.de) mittels einer
            eindeutigen Erklärung (z.&nbsp;B. E-Mail) über Ihren Entschluss informieren, diesen
            Vertrag zu widerrufen. Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die
            Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
          </p>
          <h3 className="text-lg font-medium mt-4 mb-2">Folgen des Widerrufs</h3>
          <p>
            Wenn Sie diesen Vertrag widerrufen, erstatten wir Ihnen alle Zahlungen, die wir von
            Ihnen erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag,
            an dem die Mitteilung über Ihren Widerruf bei uns eingegangen ist, über dasselbe
            Zahlungsmittel. Haben Sie verlangt, dass die Leistung während der Widerrufsfrist
            beginnen soll, so zahlen Sie uns einen angemessenen Betrag für die bis zum Widerruf
            bereits erbrachte Leistung.
          </p>
          <p>
            <strong>Vorzeitiges Erlöschen:</strong> Das Widerrufsrecht erlischt vorzeitig, wenn wir
            die Leistung vollständig erbracht haben und Sie vor Beginn der Ausführung ausdrücklich
            zugestimmt haben, dass wir mit der Leistung beginnen, und Ihre Kenntnis davon bestätigt
            haben, dass Sie Ihr Widerrufsrecht mit vollständiger Vertragserfüllung verlieren
            (§&nbsp;356 Abs.&nbsp;4, 5 BGB).
          </p>
          <h3 className="text-lg font-medium mt-4 mb-2">Muster-Widerrufsformular</h3>
          <p>
            Wenn Sie den Vertrag widerrufen wollen, können Sie folgende Vorlage per E-Mail an
            schuchardt@foerderfuchs-bildung.de senden: „Hiermit widerrufe ich den von mir
            abgeschlossenen Vertrag über den Förderfuchs Social Media Manager. Bestellt am: … /
            Name: … / Anschrift: … / Datum: …"
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">5. Social Media Integrationen</h2>
          <h3 className="text-lg font-medium mt-4 mb-2">5.1 TikTok Integration</h3>
          <p>
            Bei der Verbindung mit TikTok autorisieren Sie unsere Plattform, folgende Aktionen
            in Ihrem Namen durchzuführen:
          </p>
          <ul className="list-disc pl-6 my-4">
            <li>Abrufen Ihrer grundlegenden Profilinformationen</li>
            <li>Hochladen von Videos auf Ihr TikTok-Konto</li>
            <li>Veröffentlichen von Videos auf Ihrem TikTok-Konto</li>
          </ul>
          <p>
            Sie können diese Berechtigungen jederzeit in den Einstellungen widerrufen.
          </p>

          <h3 className="text-lg font-medium mt-4 mb-2">5.2 Weitere Plattformen</h3>
          <p>
            Ähnliche Berechtigungen gelten für Facebook, Instagram und LinkedIn. Details finden Sie
            in unserer <Link to="/datenschutz" className="text-orange-600 hover:underline">Datenschutzerklärung</Link>.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">6. Nutzerpflichten</h2>
          <p>Als Nutzer verpflichten Sie sich:</p>
          <ul className="list-disc pl-6 my-4">
            <li>Nur Inhalte zu veröffentlichen, an denen Sie die erforderlichen Rechte besitzen</li>
            <li>Keine rechtswidrigen, beleidigenden oder irreführenden Inhalte zu verbreiten</li>
            <li>Die Nutzungsbedingungen der verbundenen Social-Media-Plattformen einzuhalten</li>
            <li>Ihre Zugangsdaten vertraulich zu behandeln</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-3">7. Verantwortlichkeit für Inhalte</h2>
          <p>
            Sie sind allein verantwortlich für die Inhalte, die Sie über unsere Plattform erstellen
            und veröffentlichen. Die Plattform stellt lediglich technische Mittel zur Verfügung.
            Wir übernehmen keine Haftung für:
          </p>
          <ul className="list-disc pl-6 my-4">
            <li>Von Ihnen erstellte oder veröffentlichte Inhalte</li>
            <li>Verletzung von Rechten Dritter durch Ihre Inhalte</li>
            <li>Verstöße gegen die Richtlinien der Social-Media-Plattformen</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-3">8. KI-generierte Inhalte</h2>
          <p>
            Unsere Plattform nutzt Künstliche Intelligenz zur Unterstützung bei der Content-Erstellung.
            Bitte beachten Sie:
          </p>
          <ul className="list-disc pl-6 my-4">
            <li>KI-Vorschläge sind Empfehlungen und sollten vor Veröffentlichung geprüft werden</li>
            <li>Sie tragen die Verantwortung für alle veröffentlichten Inhalte, auch wenn diese KI-unterstützt erstellt wurden</li>
            <li>KI-generierte Inhalte können Ungenauigkeiten enthalten</li>
            <li>Je nach Einsatzzweck können Kennzeichnungspflichten für KI-generierte Inhalte bestehen (EU-KI-Verordnung, Art.&nbsp;50, anwendbar ab 02.08.2026); die Kennzeichnung veröffentlichter Inhalte obliegt Ihnen als Veröffentlichendem</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-3">9. Verfügbarkeit</h2>
          <p>
            Wir bemühen uns um eine hohe Verfügbarkeit der Plattform, können jedoch keine
            ununterbrochene Verfügbarkeit garantieren. Wartungsarbeiten werden nach Möglichkeit
            angekündigt.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">10. Haftungsbeschränkung</h2>
          <p>
            Die Haftung für leicht fahrlässige Pflichtverletzungen ist ausgeschlossen, sofern keine
            wesentlichen Vertragspflichten, Schäden aus der Verletzung des Lebens, des Körpers oder
            der Gesundheit betroffen sind.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">11. Änderungen der Nutzungsbedingungen</h2>
          <p>
            Über Änderungen dieser Nutzungsbedingungen informieren wir Sie mindestens vier Wochen
            vor Inkrafttreten per E-Mail. Widersprechen Sie einer Änderung, gilt für Sie die
            bisherige Fassung weiter; wir können das Vertragsverhältnis in diesem Fall ordentlich
            zum Ende des Abrechnungszeitraums kündigen.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">12. Kündigung und Kontolöschung</h2>
          <p>
            Sie können die Nutzung der Plattform jederzeit beenden, indem Sie alle
            Social-Media-Verbindungen in den Einstellungen trennen und Ihr Konto löschen
            (siehe auch Ziffer&nbsp;3 zur Kündigung kostenpflichtiger Pläne).
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">13. Anwendbares Recht</h2>
          <p>
            Es gilt deutsches Recht. Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz
            des Anbieters. Gegenüber Verbrauchern gilt dies nur, soweit zwingende
            verbraucherschützende Vorschriften nicht entgegenstehen.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">14. Kontakt</h2>
          <p>
            Bei Fragen zu diesen Nutzungsbedingungen kontaktieren Sie uns unter:<br />
            E-Mail: schuchardt@foerderfuchs-bildung.de
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200 flex gap-4">
          <Link to="/datenschutz" className="text-orange-600 hover:text-orange-700 font-medium">
            Datenschutzerklärung →
          </Link>
          <Link to="/settings" className="text-gray-600 hover:text-gray-700">
            ← Zurück zu den Einstellungen
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NutzungsbedingungenPage;
